export default "/images/b87c0cdf059a81e6b8f5c4b221880315.avif";